import { render, staticRenderFns } from "./BankTransactionModal.vue?vue&type=template&id=3b330dd0&scoped=true"
import script from "./BankTransactionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankTransactionModal.vue?vue&type=script&setup=true&lang=ts"
import style1 from "./BankTransactionModal.vue?vue&type=style&index=1&id=3b330dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b330dd0",
  null
  
)

export default component.exports